var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCandidateInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1411",
    "data-name": "Group 1411",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.822,
    height: 14.4,
    viewBox: "0 0 11.822 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 11.822,
    height: 14.4,
    transform: "translate(0 0)",
    fill: "#121b45"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1410",
    "data-name": "Group 1410",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M11.635,3.77,8.051.187A.464.464,0,0,0,7.693.034H2.575A1.028,1.028,0,0,0,1.551,1.057V5.152H2.575V1.057h4.1V4.128A1.027,1.027,0,0,0,7.694,5.152h3.071v8.19H4.622v1.024h6.142a1.027,1.027,0,0,0,1.024-1.024V4.128a.464.464,0,0,0-.153-.358m-3.941.358V1.262L10.56,4.128Z",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M7.7,0a.5.5,0,0,1,.37.164l3.582,3.582a.5.5,0,0,1,.164.384v9.212A1.063,1.063,0,0,1,10.764,14.4H4.587V13.308h6.142V5.186H7.692A1.064,1.064,0,0,1,6.634,4.128V1.092H2.608V5.186H1.516V1.057A1.063,1.063,0,0,1,2.574,0Zm3.058,14.332a1,1,0,0,0,.99-.99V4.129a.431.431,0,0,0-.142-.333L8.025.21A.428.428,0,0,0,7.693.068H2.574a1,1,0,0,0-.99.99v4.06h.955v-4.1H6.7V4.129a1,1,0,0,0,.99.99H10.8v8.258H4.655v.955ZM7.658,1.18l2.983,2.983H7.658Zm2.818,2.914-2.75-2.75v2.75Z",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bx-user-minus",
    transform: "translate(-15.057 -26.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M18.861,31.992a1.865,1.865,0,1,0,1.362.546A1.865,1.865,0,0,0,18.861,31.992Zm0,2.861a.911.911,0,1,1,.688-.266A.911.911,0,0,1,18.861,34.853Zm-1.907,3.815a1.431,1.431,0,0,1,1.431-1.431h.954a1.431,1.431,0,0,1,1.431,1.431v.477h.954v-.477a2.384,2.384,0,0,0-2.384-2.384h-.954A2.384,2.384,0,0,0,16,38.668v.477h.954Z",
    transform: "translate(0 0)",
    fill: "#121b45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCandidateInfo);
export default __webpack_public_path__ + "static/media/add_candidate_info.60136212c8a6887ed4a671e1b4f9abb0.svg";
export { ForwardRef as ReactComponent };